import { apiClient } from "../api/ApiClient";
import type { Sale } from "../models/Sale";
import type { Purchase } from "../models/Purchase";
import type { ReturnHistory } from "../models/ReturnHistory";
export function ReturnService(kind: "sale" | "purchase") {
  return {
    async Get(code: string): Promise<Sale | Purchase> {
      return (await apiClient.get<Sale | Purchase>(`${kind}/SearchWithCode/${encodeURIComponent(code)}`)).data;
    },
    async Save(code: string, histories: Partial<ReturnHistory>[]) {
      // Empty codes are created by the server. Existing codes identify editable histories.
      return (await apiClient.post<Sale | Purchase>(`${kind}/CreateReturn/${encodeURIComponent(code)}`, histories)).data;
    },
    async Decide(code: string, histories: ReturnHistory[], approve: boolean, refundReceived = 0) {
      const codes = [...new Set(histories.map(h=>h.Code))];
      if (!codes.length || codes.some(c=>!c)) throw Error("Reload the return requests before approving or rejecting.");
      // Use the canonical sale alias added by the updated backend.
      await apiClient.post(`${kind}/${kind==="sale"?"ApproveOrRejectSaleReturn":"ApproveOrRejectPurchaseReturn"}/${approve}/${encodeURIComponent(code)}${kind==="purchase" ? `/${refundReceived}` : ""}`, codes);
    }
  };
}
